export default {
  buttons: {
    select_table: 'Tisch auswählen',
    table: 'Tisch {{table}}',
    dine_in: 'Am Tisch',
  },
};